import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { GeneralService } from '../shared/services/general.service';
import { TabMenuSimple } from '../shared/components-generals/tab-menu-simple/tab-menu-simple';

import { Locations } from '../locations/locations/locations';
import { InputGeneral } from '../shared/inputs/input-general/input-general';
import { MatButtonModule } from '@angular/material/button';
import { BreakpointObserver } from '@angular/cdk/layout';
import { FilterGeneral } from '../shared/components-generals/filter-general/filter-general';
import { FormControl } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { Subscription } from 'rxjs';
import { HighRequest } from '../ticket/high-request/high-request';
import { MyRequests } from '../ticket/my-requests/my-requests';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
    TabMenuSimple,
    MyRequests,
    HighRequest,
    Locations,
    InputGeneral,
    MatButtonModule,
    MatBadgeModule,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent implements OnInit {
  private filterSubscription!: Subscription;
  public cont = 0;
  public statusSelected = 0;
  public taps = [
    { id: 2, descripcion: 'Puntos de conexión' }, //Ubicaciones
    { id: 1, descripcion: 'Mis solicitudes' }, // solicitudes
    { id: 0, descripcion: 'Alta de solicitud' },
  ];

  public search = new FormControl();
  public SearchFieldValue = new FormControl();

  constructor(
    private router: Router,
    private servicesGeneral: GeneralService,
    public http: HttpClient,
    public dialog: MatDialog,
    private breakpointObserver: BreakpointObserver,
  ) {}

  ngOnInit() {
    // leer Params
    const urlParams = new URLSearchParams(window.location.search);
    const status = urlParams.get('statusSelected');

    if (status !== null) {
      this.statusSelected = Number(status);
    } else {
      this.goToUrl([], { statusSelected: this.statusSelected });
    }
    this.servicesGeneral.subscribeFormSimple(this.search).subscribe((key) => {
      this.servicesGeneral.searchKey.emit(key);
    });

    this.servicesGeneral.subscribeFormSimple(this.SearchFieldValue).subscribe((key) => {
      console.log(key);
      this.servicesGeneral.emitFilterLocation.emit({
        SearchFieldValue: key !== '' && key !== null ? key : '',
        SearchField: key !== '' && key !== null ? 'Key' : '',
      });
    });

    this.filterSubscription = this.servicesGeneral.emitFilterLocation.subscribe((filterData) => {
      this.cont = 0;
      if (
        filterData.SearchField !== undefined &&
        filterData.SearchFieldValue !== undefined &&
        filterData.SearchField !== '' &&
        filterData.SearchFieldValue !== ''
      ) {
        this.cont = this.cont + 1;
      }
      if (
        filterData.Sort !== undefined &&
        filterData.SortDir !== undefined &&
        filterData.Sort !== '' &&
        filterData.SortDir !== ''
      ) {
        this.cont = this.cont + 1;
      }

      if (filterData.SearchField != 'Key') {
        this.SearchFieldValue.setValue('');
      }
    });
  }

  ngOnDestroy() {
    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }
  }

  public goToUrl(route: string[], queryParams: { [key: string]: string | number }) {
    this.servicesGeneral.goToUrl(route, queryParams, true);
  }

  public onStatusSelectedChange(event: number) {
    if (this.statusSelected != event) {
      this.goToUrl([], { statusSelected: event });
    }
  }

  public openFilter(): void {
    const isMobile = this.breakpointObserver.isMatched('(max-width: 640px)');
    const dialogRef = this.dialog.open(FilterGeneral, {
      width: isMobile ? '450px' : '700px',
      maxWidth: '90vw',
      height: 'auto',
      disableClose: true,
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(() => {});
  }
}
